import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, CreditCard, ShieldCheck, ArrowRight } from 'lucide-react';
export function FeesSection() {
  return <section id="fees" className="py-12 lg:py-16 bg-cream" data-id="element-151">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        <div className="text-center max-w-xl mx-auto mb-10" data-id="element-153">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-charcoal mb-3" data-id="element-154">
            Fees & Policies
          </h2>
          <p className="text-charcoal/70 text-base font-medium" data-id="element-155">
            Transparent pricing and flexible payment options.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-6" data-id="element-156">
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-157">
            <div className="bg-white rounded-xl p-6 border border-charcoal/10" data-id="element-158">
              <h3 className="font-heading text-lg font-bold text-charcoal mb-2" data-id="element-159">
                Individual Session
              </h3>
              <div className="flex items-baseline gap-1.5 mb-3" data-id="element-160">
                <span className="text-3xl font-bold text-olive" data-id="element-161">$160</span>
                <span className="text-charcoal/50 font-medium text-sm" data-id="element-162">
                  / 50 min
                </span>
              </div>
              <p className="text-charcoal/70 mb-4 text-sm font-medium" data-id="element-163">
                One-on-one therapy sessions focused on your personal goals and
                healing.
              </p>
              <ul className="space-y-2" data-id="element-164">
                <li className="flex items-start gap-2 text-sm text-charcoal/80" data-id="element-165">
                  <CheckCircle2 size={16} className="text-olive flex-shrink-0 mt-0.5" data-id="element-166" />
                  <span data-id="element-167">In-person or Virtual</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-charcoal/80" data-id="element-168">
                  <CheckCircle2 size={16} className="text-olive flex-shrink-0 mt-0.5" data-id="element-169" />
                  <span data-id="element-170">Personalized treatment plan</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-6 border-2 border-olive shadow-soft relative" data-id="element-171">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-olive text-white px-3 py-0.5 rounded-full text-xs font-bold tracking-wide uppercase" data-id="element-172">
                Most Common
              </div>
              <h3 className="font-heading text-lg font-bold text-charcoal mb-2" data-id="element-173">
                Couples Session
              </h3>
              <div className="flex items-baseline gap-1.5 mb-3" data-id="element-174">
                <span className="text-3xl font-bold text-olive" data-id="element-175">$180</span>
                <span className="text-charcoal/50 font-medium text-sm" data-id="element-176">
                  / 50 min
                </span>
              </div>
              <p className="text-charcoal/70 mb-4 text-sm font-medium" data-id="element-177">
                Joint sessions to improve communication and resolve relationship
                conflicts.
              </p>
              <ul className="space-y-2" data-id="element-178">
                <li className="flex items-start gap-2 text-sm text-charcoal/80" data-id="element-179">
                  <CheckCircle2 size={16} className="text-olive flex-shrink-0 mt-0.5" data-id="element-180" />
                  <span data-id="element-181">In-person or Virtual</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-charcoal/80" data-id="element-182">
                  <CheckCircle2 size={16} className="text-olive flex-shrink-0 mt-0.5" data-id="element-183" />
                  <span data-id="element-184">Conflict resolution tools</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-5 space-y-4" data-id="element-185">
            <div className="bg-white rounded-xl p-6 border border-charcoal/10" data-id="element-186">
              <div className="flex items-center gap-3 mb-3" data-id="element-187">
                <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive" data-id="element-188">
                  <ShieldCheck size={20} data-id="element-189" />
                </div>
                <h3 className="font-heading text-base font-bold text-charcoal" data-id="element-190">
                  Insurance Coverage
                </h3>
              </div>
              <div className="bg-olive/10 border border-olive/20 rounded-lg p-3 mb-3" data-id="element-191">
                <p className="text-charcoal font-extrabold text-sm leading-relaxed" data-id="element-192">
                  Direct billing for most major health insurance such as
                  Manulife, Canada Life, TELUS Health, Equitable Life of Canada
                  and many more.
                </p>
              </div>
              <p className="text-charcoal/70 text-sm mb-3 font-medium leading-relaxed" data-id="element-193">
                Services may be covered by your health insurance or employee
                benefit plan. I provide detailed receipts for reimbursement.
              </p>
              <p className="text-charcoal/80 text-sm font-bold" data-id="element-194">
                Check if your provider covers "Registered Social Workers".
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-charcoal/10" data-id="element-195">
              <div className="flex items-center gap-3 mb-3" data-id="element-196">
                <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive" data-id="element-197">
                  <CreditCard size={20} data-id="element-198" />
                </div>
                <h3 className="font-heading text-base font-bold text-charcoal" data-id="element-199">
                  Payment & Policies
                </h3>
              </div>
              <ul className="space-y-2 text-sm text-charcoal/80 mb-4 font-medium" data-id="element-200">
                <li className="flex justify-between border-b border-charcoal/10 pb-2" data-id="element-201">
                  <span data-id="element-202">Accepted Methods</span>
                  <span className="font-bold" data-id="element-203">Credit Card, e-Transfer</span>
                </li>
                <li className="flex justify-between border-b border-charcoal/10 pb-2" data-id="element-204">
                  <span data-id="element-205">Cancellation Policy</span>
                  <span className="font-bold" data-id="element-206">48 hours notice</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center mt-8" data-id="element-207">
          <Link to="/fees" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-6 py-3 rounded-full font-bold text-base transition-all shadow-soft min-h-[48px] tracking-wide" data-id="element-208">
            View Full Pricing
            <ArrowRight size={16} className="ml-2" data-id="element-209" />
          </Link>
        </div>
      </div>
    </section>;
}